import type { Dispatch, SetStateAction } from 'react';
import type { IInitialAccountAccessFormValues, TAccountAccessFormValues } from '../types';

export const submitForm = async (
  values: TAccountAccessFormValues | IInitialAccountAccessFormValues,
  setErrors: Dispatch<SetStateAction<string[]>>,
  resetRecaptcha: () => void,
  setSuccess: Dispatch<SetStateAction<boolean>>,
) => {
  const extractMessage = (error: unknown) => {
    if (error instanceof Error) return error.message;
    if (typeof error === 'object') {
      return JSON.stringify(error);
    }
    return String(error);
  };

  const sendToHeap = (error: unknown) => {
    const message = extractMessage(error);
    return window?.heap?.track?.('Form Submission Error', {
      emailAddress: values?.email ?? '',
      formName: 'Account Access Request Form',
      host: process.env.GATSBY_HOST ?? '',
      message: message ?? '',
      rawJson: JSON.stringify(error) ?? '',
    });
  };

  /**
   * Check for a token in our query string. If we have one
   * it means we want to skip the ReCaptcha for our test-account-access-form test.
   **/
  const token = new URL(location.href).searchParams.get('token');
  if (token) {
    values.token = token;
  }

  if (
    !token &&
    values['g-recaptcha-response'] === ''
    && (process.env.NETLIFY === 'true' && process.env.CONTEXT === 'production')
  ) {
    const reCaptchaError = ['reCaptcha is required'];
    sendToHeap(reCaptchaError);
    setErrors(reCaptchaError);
    return false;
  }

  try {
    const submissionResponse = await fetch('/api/hcSupportFormSubmission', {
      method: 'POST',
      body: JSON.stringify(values),
      headers: {
        'content-type': 'application/json',
      },
    });

    const submissionData = await submissionResponse.json();
    if (submissionData.success) {
      setSuccess(true);

    } else {
      sendToHeap(submissionData.errors);
      setErrors(submissionData.errors);
      resetRecaptcha();
    }

  } catch (error) {
    sendToHeap(error);
    setErrors(['Something went wrong while submitting the form']);
    resetRecaptcha();
  }

  return true;
};
